'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();

import { RootLoading } from '@workspace/ui';
import { useEffect } from 'react';
import { useAuthStore } from '@/stores/authStore';

export default function PermissionsProvider({
  children,
  permissionMap,
}: {
  children: React.ReactNode;
  permissionMap: Record<string, number>;
}) {
  const setPermissionMap = useAuthStore((s) => s.setPermissionMap);
  const isPermissionMapLoaded = useAuthStore((s) => s.isPermissionMapLoaded);

  useEffect(() => {
    setPermissionMap(permissionMap);
  }, [permissionMap, setPermissionMap]);

  if (!isPermissionMapLoaded) {
    return <RootLoading />;
  }

  return children;
}
